import { useState, useEffect, useCallback, useRef } from 'react'
import PropTypes from 'prop-types'
import ReactHtmlParser from 'react-html-parser'
import classnames from 'classnames'
import useWillMount from '@/hooks/useWillMount'
import RevealImage from '@/components/RevealImage'
import utils from '@/utils'
import styles from './style'

const TextBlock = ({
  className,
  content,
}) => {
  const $root = useRef()
  const [transformedContent, setTransformedContent] = useState()

  const transformContent = useCallback(() => {
    const transform = (node) => { // eslint-disable-line
      if (node.type === 'tag' && node.name === 'a') {
        return (
          <RevealImage
            key={node.children[0].data}
            label={node.children[0].data}
            image={node.attribs.href}
          />
        )
      }
    }
    setTransformedContent(ReactHtmlParser(utils.strings.removeParagraph(content), { transform }))
  }, [content])

  useWillMount(() => {
    transformContent()
  })

  useEffect(() => {
    transformContent()
  }, [content])

  return (
    <div
      ref={$root}
      className={classnames({
        [styles.wrapper]: styles.wrapper,
        [className]: className,
      })}
    >
      {transformedContent}
    </div>
  )
}

TextBlock.propTypes = {
  className: PropTypes.string,
  content: PropTypes.string.isRequired,
}

TextBlock.defaultProps = { className: '' }

export default TextBlock
